import { createAction, handleActions } from 'redux-actions';
import { ResultsLegFragment } from '@websky/graphql';

export const setLegInView = createAction<ResultsLegFragment>('setLegInView');

export default handleActions<ResultsLegFragment>(
	{
		[setLegInView.toString()]: (_, { payload }) => payload
	},
	null
);
